import React, { useEffect, useState } from 'react';
import Sidebar from '../components/Sidebar';
import TopBar from '../components/Dashboard/TopBar';
import { Utensils, Layers, CalendarCheck, TrendingUp } from 'lucide-react';

const API_BASE = "https://admin.theporch.in/api";

const Layout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [stats, setStats] = useState({
    totalDishes: 0,
    totalCategories: 0,
    totalReservations: 0
  });

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [menuRes, catRes, resvRes] = await Promise.all([
          fetch(`${API_BASE}/menu_items`),
          fetch(`${API_BASE}/categories`),
          fetch(`${API_BASE}/cafe_reservations`)
        ]);

        const menu = await menuRes.json();
        const categories = await catRes.json();
        const reservations = await resvRes.json();

        setStats({
          totalDishes: menu.length,
          totalCategories: categories.length,
          totalReservations: reservations.length
        });
      } catch (err) {
        console.error("Dashboard Fetch Error:", err);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      <style>{`
        * { margin: 0; padding: 0; box-sizing: border-box; }
        html, body { height: 100%; font-family: 'Open Sans', sans-serif; background-color: #f4f7fe; }

        .layout-wrapper {
          display: flex;
          height: 100vh;
          width: 100%;
          overflow: hidden;
          position: relative;
        }

        .main-container {
          flex: 1;
          display: flex;
          flex-direction: column;
          overflow-y: auto;
          transition: all 0.3s ease;
          
          /* Desktop Default */
          margin-left: 260px;
          width: calc(100% - 260px);
          min-width: 0; /* Prevents flex items from overflowing */
        }

        .dashboard-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 20px;
          padding: 20px;
        }

        .stat-card {
          background: white;
          padding: 20px;
          border-radius: 16px;
          display: flex;
          align-items: center;
          gap: 15px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.05);
        }

        .main-content-area {
          padding: 0 20px 20px 20px;
          flex: 1;
          width: 100%;
        }

        /* Tablet & Mobile (Standard Hamburger View) */
        @media (max-width: 1024px) {
          .main-container {
            margin-left: 0;
            width: 100%;
          }
          
          /* If you want the content to shift when sidebar opens on mobile: */
          /* .main-container.shifted { margin-left: 260px; } */
        }

        @media (max-width: 640px) {
          .dashboard-grid {
            grid-template-columns: 1fr;
            padding: 15px;
            gap: 15px;
          }
        }
      `}</style>

      <div className="layout-wrapper">
        <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

        {/* Added dynamic class for logic if needed */}
        <main className={`main-container ${isSidebarOpen ? 'shifted' : ''}`}>
          <TopBar
            onMenuClick={toggleSidebar}
            isSidebarOpen={isSidebarOpen}
          />

          <div className="dashboard-grid">
            <StatCard icon={<Utensils color="#4318FF"/>} label="Total Dishes" value={stats.totalDishes} />
            <StatCard icon={<Layers color="#39B8FF"/>} label="Categories" value={stats.totalCategories} />
            <StatCard icon={<CalendarCheck color="#01B574"/>} label="Reservations" value={stats.totalReservations} />
            <StatCard icon={<TrendingUp color="#FFB547"/>} label="Server Status" value="Live" />
          </div>

          <div className="main-content-area">
            {children}
          </div>
        </main>
      </div>
    </>
  );
};

const StatCard = ({ icon, label, value }) => (
  <div className="stat-card">
    <div style={{
      background: '#F4F7FE',
      padding: '12px',
      borderRadius: '12px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      {icon}
    </div>
    <div>
      <p style={{ color: '#A3AED0', fontSize: '14px' }}>{label}</p>
      <h2 style={{ color: '#2B3674', fontSize: '22px' }}>{value}</h2>
    </div>
  </div>
);

export default Layout;